<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title> {{ title }} </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form [formGroup]="productCategoryForm" (ngSubmit)="onSave()">
    <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

    <ion-item lines="none">
      <ion-label position="stacked">Product Category Name*</ion-label>
      <ion-input
        type="text"
        name=""
        formControlName="name"
        clearInput
        class="sm-input-border"
      ></ion-input>
    </ion-item>
    <ion-item *ngIf="!productCategoryName.valid && submitted">
      <p *ngIf="productCategoryName.hasError('required')" class="sm-error">
        Oops, a product category name is required.
      </p>

      <p *ngIf="productCategoryName.hasError('maxlength')" class="sm-error">
        A product category name can't exceed 50 letters.
      </p>
    </ion-item>
  </form>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingProductCategory"
    (click)="refresh()"
  ></salonmonster-tap-retry>
</ion-content>

<ion-footer>
  <ion-grid>
    <ion-row>
      <ion-col *ngIf="this.productCategoryID != 0">
        <ion-button
          fill="outline"
          expand="block"
          color="danger"
          [disabled]="isLoading || errorOccurredWhileLoadingProductCategory"
          (click)="onProductCategoryDelete()"
        >
          Delete
        </ion-button>
      </ion-col>

      <ion-col>
        <ion-button
          class="save-button"
          expand="block"
          color="primary"
          [disabled]="isLoading || errorOccurredWhileLoadingProductCategory"
          (click)="onSave()"
        >
          Save
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
